<template>
  <v-data-table
    :headers="headers"
    :items="documents"
    item-key="id"
    v-bind="$attrs"
  >
    <template v-slot:item.name="{ item }">
      <a :href="item.url" target="_blank">{{item.name}}</a>
    </template>
    <template v-slot:item.creationDate="{ item }">
      {{ item.creationDate | formatDate }}
    </template>
    <template v-slot:item.source="{ item }">
      {{ item.source }}
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn
        icon
        small
        @click="handleEditDocument(item)"
      >
        <v-icon>mdi-pencil </v-icon>
      </v-btn>
      <SubmitButton
        icon="mdi-delete"
        small
        @click="handleDeleteDocument(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { updateDocument, deleteDocument } from '@/services'

export default {
  name: 'DocumentsTable',
  props: {
    documents: {
      type: Array,
      default: () => ([])
    },
    showSource: {
      type: Boolean,
      default: false
    },
    showType: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const headers = [
      { text: this.$tc('document.document', 1), value: 'name' },
      { text: this.$t('common.description'), value: 'description' },
      { text: this.$t('document.date'), value: 'creationDate' }
    ]
    this.showSource && headers.push({ text: this.$t('document.source'), value: 'source' })
    headers.push({ text: '', value: 'actions' })
    return { headers }
  },
  methods: {
    handleEditDocument (item) {
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'DocumentForm',
        options: { maxWidth: 650 },
        scope: {
          title: this.$t('document.edit'),
          value: item
        },
        handlers: {
          SAVE_DOCUMENT: async (document) => {
            await updateDocument(document, this.$route.params.contractId)
            this.$eventBus.$emit('CLOSE_MODAL')
            this.$eventBus.$emit('FETCH_CONTRACT')
          }
        }
      })
    },
    handleDeleteDocument (item) {
      this.$eventBus.$emit('OPEN_CONFIRM_MODAL', {
        scope: {
          message: this.$t('common.deleteConfirm', { name: item.name })
        },
        handlers: {
          yes: async () => {
            await deleteDocument(item)
            this.$eventBus.$emit('FETCH_CONTRACT')
          }
        }
      })
    }
  }
}
</script>
